module.exports = __webpack_public_path__ + "static/media/poetryImg.08e0541d.jpg";